import { render, staticRenderFns } from "./InvitationCapture.vue?vue&type=template&id=477cc60b&scoped=true&"
import script from "./InvitationCapture.vue?vue&type=script&lang=js&"
export * from "./InvitationCapture.vue?vue&type=script&lang=js&"
import style0 from "./InvitationCapture.vue?vue&type=style&index=0&id=477cc60b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477cc60b",
  null
  
)

export default component.exports